import { render } from "./MindTab.vue?vue&type=template&id=7575ae51&scoped=true"
import script from "./MindTab.vue?vue&type=script&lang=js"
export * from "./MindTab.vue?vue&type=script&lang=js"

import "./MindTab.vue?vue&type=style&index=0&id=7575ae51&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7575ae51"]])

export default __exports__